/* Cart drawer upsell: "Completá tu pack"
   - Trae recomendaciones (intent=complementary, fallback related) para el 1er ítem del carrito.
   - Filtra lo que YA está en el carrito.
   - "+Agregar" replica el patrón de product-form.js (POST /cart/add.js con sections) y
     re-renderiza el drawer con cartDrawer.renderContents().
   - Se repuebla en cada cartUpdate (el drawer reemplaza todo #CartDrawer al re-renderizar).
   Buildless: script clásico, sin imports. */
(function () {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const FETCH_LIMIT = 6; // cuántas pedir a la API
  const SHOW = 2; // cuántas mostrar en el drawer
  const EMPTY_SHOW = 3; // cuántas mostrar con el carrito vacío
  const CONTAINER_ID = 'CartDrawer-Upsell';
  const EMPTY_ID = 'CartDrawer-EmptyRecs';
  // Fuente del empty-cart: colección curada (cambiar acá si algún día existe 'mas-vendidos')
  const BEST_SELLERS_COLLECTION = 'frontpage';

  // Nunca recomendar estos (pedido de Tiago: el combo títulos+SFX no va en el upsell)
  const EXCLUDE = new Set(['pack-de-titulos-de-premiere-pro-5000-sfx-ultimate-pack']);

  const isEN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  const T = {
    title: isEN ? 'Complete your setup' : 'Completá tu pack',
    add: isEN ? 'Add' : 'Agregar',
    bestSellers: isEN ? 'Best sellers' : 'Más vendidos',
    hide: isEN ? 'Hide recommendations' : 'Ocultar recomendaciones',
    show: isEN ? 'Show recommendations' : 'Mostrar recomendaciones',
  };

  // Replegable: arranca desplegado; el estado sobrevive a los repoblados
  // dentro de la misma página (var de módulo, no storage)
  let upsellCollapsed = false;

  /* Contención: si el carrito tiene la clave, NO recomendar sus contenidos.
     '*' = contiene todo (all-in-one) → upsell oculto.
     Los packs v2 "contienen" su v1 (no recomendar v1 si v2 está en el carrito).
     La expansión es TRANSITIVA: si A contiene B y B contiene C, tener A en el
     carrito también bloquea C (ej: CapCut Creator → CapCut Titles → 5000 SFX). */
  const CONTAINS = {
    'todos-los-productos': '*',
    '2026-ultimate-editing-pack': [
      'pack-v2-titulos-premiere-pro',
      'pack-titulos-premiere-pro',
      'pack-v2-0-titulos-after-effects',
      'pack-titulos-after-effects',
    ],
    'capcut-creator-pack': ['pack-titles-capcut'],
    'pack-de-titulos-de-premiere-pro-5000-sfx-ultimate-pack': [
      'pack-titulos-premiere-pro',
      'pack-v2-titulos-premiere-pro',
      '5000-sfx-ultimate-pack',
    ],
    /* TODOS los packs de títulos ya traen el +5000 SFX (regla de Tiago:
       jamás recomendar el SFX pack si hay algún pack de títulos) */
    'pack-v2-titulos-premiere-pro': ['pack-titulos-premiere-pro', '5000-sfx-ultimate-pack'],
    'pack-v2-0-titulos-after-effects': ['pack-titulos-after-effects', '5000-sfx-ultimate-pack'],
    'pack-titulos-premiere-pro': ['5000-sfx-ultimate-pack'],
    'pack-titulos-after-effects': ['5000-sfx-ultimate-pack'],
    'pack-titles-capcut': ['5000-sfx-ultimate-pack'],
    'davinci-resolve-v1': ['5000-sfx-ultimate-pack'],
    /* Según la descripción del producto: 2026 Ultimate Editing Pack + UltraWorkflow
       + Advanced (Pack Avanzado) + VFX Premiere + Proyecto Mixed Media + Platinum
       LUTs + Titles AE/PR v1 y v2 + 5000 SFX */
    'ultimate-bundle-editors-exclusive-pack-2026': [
      '2026-ultimate-editing-pack',
      'ultraworkflow',
      'pack-de-efectos-esenciales',
      'vfx-pack-premiere-pro',
      'proyecto-mixed-media',
      'platinum-luts-pack',
      'pack-titulos-premiere-pro',
      'pack-v2-titulos-premiere-pro',
      'pack-titulos-after-effects',
      'pack-v2-0-titulos-after-effects',
      '5000-sfx-ultimate-pack',
    ],
  };

  /* Expande la contención transitivamente (profundidad acotada por si
     algún día se forma un ciclo en el mapa) */
  function expandBlocked(handle, blocked, depth) {
    const c = CONTAINS[handle];
    if (!c || c === '*') return;
    c.forEach((h) => {
      if (!blocked.has(h)) {
        blocked.add(h);
        if (depth < 5) expandBlocked(h, blocked, depth + 1);
      }
    });
  }

  function money(cents) {
    const n = (Number(cents) || 0) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }

  async function fetchRecs(productId, intent) {
    try {
      const url = ROOT + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) +
        '&limit=' + FETCH_LIMIT + '&intent=' + intent;
      const data = await fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      return (data && data.products) || [];
    } catch (e) {
      return [];
    }
  }

  function pickVariant(p) {
    if (!p.variants || !p.variants.length) return null;
    return p.variants.find((v) => v.available) || p.variants[0];
  }

  function cardHTML(p) {
    const v = pickVariant(p);
    if (!v) return '';
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const imgSrc = img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=120' : '';
    const hasCompare = p.compare_at_price && p.compare_at_price > p.price;
    const priceHTML = (hasCompare ? '<s>' + money(p.compare_at_price) + '</s> ' : '') +
      '<strong>' + money(p.price) + '</strong>';
    const available = v.available !== false;
    return (
      '<div class="cart-upsell__card">' +
        (imgSrc ? '<img class="cart-upsell__img" src="' + esc(imgSrc) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="cart-upsell__img"></span>') +
        '<div class="cart-upsell__info">' +
          '<a class="cart-upsell__name" href="' + ROOT + 'products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
          '<div class="cart-upsell__price" translate="no">' + priceHTML + '</div>' +
        '</div>' +
        '<button type="button" class="cart-upsell__add" data-upsell-add data-variant-id="' + v.id + '"' +
          (available ? '' : ' disabled') + ' aria-label="' + esc(T.add + ' ' + p.title) + '">' +
          '<span class="cart-upsell__add-plus" aria-hidden="true">+</span>' +
        '</button>' +
      '</div>'
    );
  }

  async function onAdd(e) {
    const btn = e.currentTarget;
    const id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    btn.classList.add('is-loading');
    btn.disabled = true;

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer && cartDrawer.getSectionsToRender
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    try {
      const res = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });
      const parsed = await res.json();
      if (parsed && parsed.status) {
        // error (ej: agotado) — re-habilitar
        btn.classList.remove('is-loading');
        btn.disabled = false;
        return;
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsed);
        // igual que product-form.js de Dawn: al agregar desde carrito vacío,
        // limpiar is-empty del propio <cart-drawer> (si no, el header queda oculto)
        cartDrawer.classList.remove('is-empty');
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', productVariantId: id });
      }
      // renderContents ya reemplazó #CartDrawer (contenedor incluido); repoblar:
      loadUpsell();
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }

  /* La API de colecciones devuelve precios como string ("24.99") e imágenes
     como objetos {src} — normalizamos a la forma de recommendations (centavos). */
  function normalizeCollectionProduct(p) {
    const v = (p.variants && p.variants[0]) || {};
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      featured_image: (p.images && p.images[0] && p.images[0].src) || '',
      price: Math.round(parseFloat(v.price || '0') * 100),
      compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null,
      variants: (p.variants || []).map((x) => ({ id: x.id, available: x.available })),
    };
  }

  /* Carrito vacío: "Más vendidos" desde la colección curada.
     El box se RE-CONSULTA después de los fetch: el drawer puede re-renderizarse
     entero (renderContents) mientras esperábamos la respuesta, dejando la
     referencia vieja huérfana. */
  async function loadEmptyRecs() {
    if (!document.getElementById(EMPTY_ID)) return;
    try {
      const data = await fetch(ROOT + 'collections/' + BEST_SELLERS_COLLECTION + '/products.json?limit=12', {
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());
      const box = document.getElementById(EMPTY_ID);
      if (!box) return;
      const prods = (data.products || [])
        .map(normalizeCollectionProduct)
        .filter((p) => !EXCLUDE.has(p.handle) && p.variants.length)
        .slice(0, EMPTY_SHOW);
      if (!prods.length) {
        box.hidden = true;
        return;
      }
      box.innerHTML =
        '<p class="cart-upsell__title">' + esc(T.bestSellers) + '</p>' +
        '<div class="cart-upsell__list">' + prods.map(cardHTML).join('') + '</div>';
      box.hidden = false;
      box.querySelectorAll('[data-upsell-add]').forEach((b) => b.addEventListener('click', onAdd));
    } catch (e) {
      const box = document.getElementById(EMPTY_ID);
      if (box) box.hidden = true;
    }
  }

  let loading = false;
  let rerun = false;
  async function loadUpsell() {
    if (!document.getElementById(CONTAINER_ID)) return;
    if (loading) {
      // llegó otro pedido mientras fetcheábamos (p.ej. renderContents pisó el
      // drawer): re-correr al terminar para poblar el contenedor nuevo
      rerun = true;
      return;
    }
    loading = true;
    try {
      const cart = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      // re-consultar SIEMPRE tras cada await (ver nota en loadEmptyRecs)
      let container = document.getElementById(CONTAINER_ID);
      if (!container) return;
      if (!cart || !cart.items || !cart.items.length) {
        container.hidden = true;
        container.innerHTML = '';
        await loadEmptyRecs();
        return;
      }
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const seed = cart.items[0].product_id;

      // set de handles bloqueados por contención (v1 tapado por v2, bundles,
      // all-in-one), expandido transitivamente
      let blockAll = false;
      const blocked = new Set();
      cart.items.forEach((i) => {
        if (CONTAINS[i.handle] === '*') blockAll = true;
        else expandBlocked(i.handle, blocked, 0);
      });
      if (blockAll) {
        container.hidden = true;
        container.innerHTML = '';
        return;
      }

      let recs = await fetchRecs(seed, 'complementary');
      if (!recs.length) recs = await fetchRecs(seed, 'related');

      container = document.getElementById(CONTAINER_ID);
      if (!container) return;

      // filtrar lo que ya está en el carrito, lo contenido/superado, lo excluido + dedup
      const seen = new Set();
      recs = recs.filter((p) => {
        if (inCart.has(p.id) || blocked.has(p.handle) || EXCLUDE.has(p.handle) || seen.has(p.id)) return false;
        seen.add(p.id);
        return true;
      }).slice(0, SHOW);

      if (!recs.length) {
        container.hidden = true;
        container.innerHTML = '';
        return;
      }

      container.innerHTML =
        '<div class="cart-upsell__head">' +
          '<p class="cart-upsell__title">' + esc(T.title) + '</p>' +
          '<button type="button" class="cart-upsell__toggle" data-upsell-toggle aria-expanded="' + !upsellCollapsed + '" aria-label="' + esc(upsellCollapsed ? T.show : T.hide) + '">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"></path></svg>' +
          '</button>' +
        '</div>' +
        '<div class="cart-upsell__body"><div class="cart-upsell__list">' + recs.map(cardHTML).join('') + '</div></div>';
      container.classList.toggle('cart-upsell--collapsed', upsellCollapsed);
      container.hidden = false;
      container.querySelectorAll('[data-upsell-add]').forEach((b) => b.addEventListener('click', onAdd));
      const tog = container.querySelector('[data-upsell-toggle]');
      if (tog) {
        tog.addEventListener('click', () => {
          upsellCollapsed = !upsellCollapsed;
          container.classList.toggle('cart-upsell--collapsed', upsellCollapsed);
          tog.setAttribute('aria-expanded', String(!upsellCollapsed));
          tog.setAttribute('aria-label', upsellCollapsed ? T.show : T.hide);
        });
      }
    } finally {
      loading = false;
      if (rerun) {
        rerun = false;
        setTimeout(loadUpsell, 0);
      }
    }
  }

  function init() {
    loadUpsell();
    // Repoblar tras cualquier cambio de carrito (qty/remove/add de otros lados)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // el drawer ya se re-renderizó; esperar un tick a que exista el contenedor
        setTimeout(loadUpsell, 0);
      });
    }
    // Al abrir el drawer por el ícono, el carrito puede haber cambiado
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) cartLink.addEventListener('click', () => setTimeout(loadUpsell, 50));

    // product-form.js publica cartUpdate PERO difiere renderContents vía
    // requestIdleCallback (hasta 300ms): ese render pisa el contenedor ya
    // poblado. Parcheamos renderContents para repoblar SIEMPRE después de
    // cualquier re-render del drawer (cubre product-form, quick-add y flujos
    // custom). whenDefined porque cart-drawer.js carga después que este script.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(() => {
        const CD = customElements.get('cart-drawer');
        if (!CD || typeof CD.prototype.renderContents !== 'function') return;
        const orig = CD.prototype.renderContents;
        CD.prototype.renderContents = function () {
          const out = orig.apply(this, arguments);
          setTimeout(loadUpsell, 0);
          return out;
        };
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
